export default "__VITE_ASSET__BEq$TNps__"